module.exports = __webpack_public_path__ + "static/media/speakers-banner.fd49cca2.jpg";